import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavigationIcon, Text, View } from '@24i/nxg-sdk-quarks';
import { useTheme } from '@24i/nxg-sdk-higgs';
import { isPlatformWeb } from 'renative';
import { getStyles } from './styles';

const NoPurchases = () => {
    const { t } = useTranslation();
    const { theme } = useTheme();
    const styles = getStyles(theme);
    const iconSize = isPlatformWeb ? 80 : 72;

    return (
        <View style={styles.wrapper}>
            <View style={styles.cartIconWrapper}>
                <NavigationIcon iconName="purchase" size={iconSize} />
            </View>
            <View style={styles.infoWrapper}>
                <Text style={styles.noPurchasesTitle}>{t('tvod.manage.noData.title')}</Text>
                <View style={styles.purchasesShowUpHereLabelWrapper}>
                    <Text style={styles.purchasesShowUpHereLabel}>
                        {t('tvod.manage.noData.description')}
                    </Text>
                </View>
            </View>
        </View>
    );
};

export default NoPurchases;
